// extracted by mini-css-extract-plugin
module.exports = {"b13tqz5":"b13tqz5","n4lbox0":"n4lbox0"};